/**
 * Languages a player can pick on their phone (airports, and venues that turned on
 * « Laisser chaque joueur choisir sa langue » in Mon compte — see utils/playerLanguage).
 * Must stay a subset of the bundled i18n locales (see config/translations).
 * The order here is the order shown in the flag picker.
 */
export type GamepadLanguage = {
    /** i18n locale code. */
    code: string;
    /** Emoji flag (renders natively on iOS/Android phones). */
    flag: string;
    /** Native short label shown under the flag. */
    label: string;
};

export const GAMEPAD_LANGUAGES: readonly GamepadLanguage[] = [
    { code: 'fr', flag: '🇫🇷', label: 'Français' },
    { code: 'en', flag: '🇬🇧', label: 'English' },
    { code: 'es', flag: '🇪🇸', label: 'Español' },
    { code: 'it', flag: '🇮🇹', label: 'Italiano' },
    { code: 'pt', flag: '🇵🇹', label: 'Português' },
    { code: 'de', flag: '🇩🇪', label: 'Deutsch' },
    { code: 'zh', flag: '🇨🇳', label: '中文' },
] as const;

export const SUPPORTED_GAMEPAD_LANGS: readonly string[] = GAMEPAD_LANGUAGES.map((l) => l.code);

/** localStorage key holding the passenger's chosen language (per device, survives reload). */
export const GAMEPAD_LANGUAGE_KEY = 'gamepadLanguage';

/** localStorage key holding the venue (clientID) where that language was chosen (absent on older saves). */
export const GAMEPAD_LANGUAGE_VENUE_KEY = 'gamepadLanguageVenue';
